import { SOCKET_URL_SERVER } from "../constans/url";
import canvasState from "../store/canvasState";
import socketState from "../store/socketState";
import toolState from "../store/toolState";
import Brush from "../tools/Brush";
import Rect from "../tools/Rect";
import { FigureTypes, MessageMethod, MessageType } from "../types/types";

export const connectSockets = (id: string) => {
    if(socketState.username) {
        const socket = new WebSocket(SOCKET_URL_SERVER);
        socketState.setSocket(socket);
        socketState.setSessionId(id);
        toolState.setTool(new Brush(canvasState.canvas, socketState.socket, socketState.sessionId))

        socket.onopen = () => {
            socket.send(JSON.stringify({
                id: id,
                username: socketState.username,
                method: MessageMethod.CONNECTION,
            } as MessageType))
        }

        socket.onmessage = (event) => {
            const msg: MessageType = JSON.parse(event.data)
            switch (msg.method) {

                case MessageMethod.CONNECTION:
                    console.log(`Пользователь ${msg.username} подключился`);
                    break;

                case MessageMethod.DRAW:
                    drawHandler(msg);
                    break;

                default:
                    break;
            }
        }
    }
}

const drawHandler = (msg: MessageType) => {
    const {x, y, height, type, width, color} = msg.figure;
    const ctx = canvasState.canvas?.getContext('2d');
    switch (type) {
        case FigureTypes.BRUSH:
            Brush.draw(ctx, x, y, color);
            break;
        
        case FigureTypes.FINISH:
            ctx?.beginPath()
            break;
    
        case FigureTypes.RECT:
            Rect.staticDraw(ctx, x, y, width, height, color)
            break;

        case FigureTypes.CLEAR:
            toolState.clearAll()
            break;

        default:
            break;
    }
}